import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  standalone: true,
  imports: [MatButtonModule, TranslatePipe],
})
export class CookiePolicyComponent {
  constructor(
    private readonly _bottomSheetRef: MatBottomSheetRef<CookiePolicyComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
  ) {}

  public onAccept() {
    this._bottomSheetRef.dismiss();
  }
}
